import Vue from 'vue'
import App from './App.vue'
import './assets/style.scss'
import './assets/reset.css'
import vuetify from './plugins/vuetify'
import VBodyScrollLock from 'v-body-scroll-lock'
import moment from 'vue-moment'
import router from './router/index'
import store from './store/index'
import VueClipboards from 'vue-clipboards'
//import VEmojiPicker from 'v-emoji-picker';

import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import VueNotifications from './mixins/notifications'

Vue.use(ToastPlugin)
//Vue.use(VEmojiPicker);
Vue.use(moment)
Vue.use(VBodyScrollLock)
Vue.config.productionTip = false
Vue.mixin(VueNotifications)
Vue.use(VueClipboards)

new Vue({
  vuetify,
  router,
  store,
  VBodyScrollLock,
  render: h => h(App)
}).$mount('#app')
